import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ViewChild, ElementRef, inject, Injector, afterNextRender } from '@angular/core';

@Component({
  selector: 'app-learning-quiz-completion',
  templateUrl: './learning-quiz-completion.component.html',
  styleUrls: ['./learning-quiz-completion.component.scss'],
  standalone: false
})
export class LearningQuizCompletionComponent implements OnInit, OnDestroy {
  @Input() score: number = 0;
  @Input() totalQuestions: number = 0;
  @Input() lessonTitle: string = '';
  @Input() quizTitle: string = '';
  @Input() passingScore: number = 80;
  
  @Output() retakeQuiz = new EventEmitter<void>();
  @Output() revisitLesson = new EventEmitter<void>();
  @Output() backToLibrary = new EventEmitter<void>();
  @Output() nextLesson = new EventEmitter<void>();

  @ViewChild('backToLibraryBtn', { read: ElementRef }) private backToLibraryBtn?: ElementRef<HTMLButtonElement>;

  isXsScreen: boolean = false;
  private resizeListener: any;

  private readonly injector = inject(Injector);

  ngOnInit() {
    this.checkScreenSize();
    this.resizeListener = this.checkScreenSize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.scrollTo({ top: 0, behavior: 'smooth' });

    afterNextRender(
      () => {
        this.backToLibraryBtn?.nativeElement?.focus();
      },
      { injector: this.injector },
    );
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resizeListener);
  }

  private checkScreenSize() {
    this.isXsScreen = window.innerWidth < 576;
  }

  get percentage(): number {
    if (this.totalQuestions <= 0) return 0;
    const rawPercentage = (this.score / this.totalQuestions) * 100;
    return Math.round(rawPercentage * 100) / 100;
  }

  get passed(): boolean {
    return this.percentage >= this.passingScore;
  }

  get questionsNeeded(): number {
    return Math.ceil((this.passingScore / 100) * this.totalQuestions);
  }

  onRetakeQuiz(): void {
    this.retakeQuiz.emit();
  }

  onRevisitLesson(): void {
    this.revisitLesson.emit();
  }

  onBackToLibrary(): void {
    this.backToLibrary.emit();
  }

  onNextLesson(): void {
    this.nextLesson.emit();
  }
}